// Sequence shortcuts ("g s") are bound with tinykeys, single-key shortcuts
// ("s") with react-hotkeys-hook. Both see the same keydown, so the second key
// of a sequence has to be swallowed by the single-key layer.
const SEQUENCE_PREFIX_KEYS = new Set(["g"])

// Passed to tinykeys so its sequence window and the guard share one clock.
export const NAV_SEQUENCE_TIMEOUT = 500

// Grace on top of the tinykeys window: a late setTimeout must never let a
// sequence and a single-key shortcut both fire off the same keypress.
export const SEQUENCE_GUARD_TIMEOUT = NAV_SEQUENCE_TIMEOUT + 150

let sequenceStartedAt = 0

// Browser autofill fires keydown with no key, so the key may be missing.
export function isSequencePrefixKey(key: string | undefined) {
	return !!key && SEQUENCE_PREFIX_KEYS.has(key.toLowerCase())
}

export function markSequencePrefix(key: string | undefined) {
	if (isSequencePrefixKey(key)) {
		sequenceStartedAt = Date.now()
	}
}

export function isSequenceInProgress() {
	return Date.now() - sequenceStartedAt < SEQUENCE_GUARD_TIMEOUT
}

export function resetSequenceTracking() {
	sequenceStartedAt = 0
}
